import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import DownloadButtons from "./DownloadButtons"; // adjust path as needed

const TranscreatePages: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const bookId = location.state as string; //"68265e7d24b269f244ca8e33"; //location.state as string;
  const [pages, setPages] = useState<number[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prompt, setPrompt] = useState("");
  const [currentImage, setCurrentImage] = useState("");
  const [modelOutputs, setModelOutputs] = useState<string[]>([]);
  const [selectedOutput, setSelectedOutput] = useState<string | null>(null);
  const [completedPages, setCompletedPages] = useState(new Set<number>());
  const [transcreationDone, setTranscreationDone] = useState(false);

  useEffect(() => {
    const getPages = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/book/${bookId}`
      );
      const totalPages = res.data.page_count || res.data.book?.length || 2;
      setPages(Array.from({ length: totalPages }, (_, i) => i));
    };
    getPages();
  }, []);

  useEffect(() => {
    const getPageImage = async () => {
      const page = pages[currentIndex];
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-book-page/${bookId}/${page}`
      );
      setCurrentImage(`data:image/jpeg;base64,${res.data}`);
      setModelOutputs([]);
      setSelectedOutput(null);
    };
    if (pages.length) getPageImage();
  }, [currentIndex, pages]);

  const handlePromptSubmit = async () => {
    setLoading(true);
    try {
      const page = pages[currentIndex];
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/transcreate-page/${bookId}/${page}`,
        { params: { prompt } }
      );
      const images = res.data.map(
        (b64: string) => `data:image/jpeg;base64,${b64}`
      );
      setModelOutputs(images);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setLoading(false); // Hide the spinner
    }
  };

  const handleUpload = async () => {
    if (!selectedOutput) return alert("Select one image!");
    const page = pages[currentIndex];
    const b64 = selectedOutput.split(",")[1];
    console.log("b64", b64);
    await axios.post(
      `${process.env.REACT_APP_API_URL}/upload-transcreate/${bookId}/${page}`,
      { img_selection: b64 }
    );
    setCompletedPages((prev) => {
      const updated = new Set(prev).add(currentIndex);
      if (updated.size === pages.length) setTranscreationDone(true);
      return updated;
    });
    const next = currentIndex + 1;
    if (next < pages.length) {
      setCurrentIndex(next);
      setPrompt("");
    } else {
      alert("Transcreation complete!");
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      {!transcreationDone ? (
        <>
          <h2>Page {currentIndex + 1}</h2>
          <img
            src={currentImage}
            alt="Current Page"
            style={{
              maxWidth: "100%",
              maxHeight: "60vh",
              marginBottom: "1rem",
            }}
          />

          <input
            type="text"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Enter an image-editing prompt to localize this image to your target culture..."
            style={{ width: "100%", padding: "0.5rem", marginBottom: "1rem" }}
          />
          <button onClick={handlePromptSubmit} disabled={loading}>
            Generate Options{" "}
            {loading && (
              <span
                style={{
                  marginLeft: "10px",
                  width: "16px",
                  height: "16px",
                  border: "2px solid #ccc",
                  borderTop: "2px solid #007BFF",
                  borderRadius: "50%",
                  display: "inline-block",
                  animation: "spin 1s linear infinite",
                }}
              ></span>
            )}
          </button>
          <style>
            {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
          </style>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "1rem",
              marginTop: "1rem",
            }}
          >
            {modelOutputs.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Output ${idx}`}
                onClick={() => setSelectedOutput(img)}
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "cover",
                  border:
                    selectedOutput === img
                      ? "3px solid #0070f3"
                      : "1px solid #ccc",
                  cursor: "pointer",
                  borderRadius: "8px",
                }}
              />
            ))}
          </div>

          <button
            disabled={!selectedOutput}
            onClick={handleUpload}
            style={{ marginTop: "1rem" }}
          >
            Submit Selection
          </button>
        </>
      ) : (
        <>
          <h3>Feedback Form</h3>
          <iframe
            src="https://tally.so/r/nPgP05"
            width="100%"
            height="500"
            frameBorder="0"
            title="Feedback Form"
          ></iframe>

          <DownloadButtons bookId={bookId} />
        </>
      )}
    </div>
  );
};

export default TranscreatePages;
